import React from 'react';
import {VerificationsCtx, VerificationsCtxProvider} from 'components/dataProviders/tasks.reports.verifications';
import { TooltipedPicture } from 'components/files/FilesList';
import {makeStyles} from '@material-ui/core/styles';



function TaskReportVerifications({verification, classes})
{
  let value = <></>
  let empty = <span class={classes.emptyField}>No hay contenido</span>
  switch(verification.verificationType)
  {
    case "bool_slider":
      value = <div className={classes.infoField}>{verification.value && verification.value.toLowerCase() === "true" ? "Confirmado" : "Sin confirmar"}</div>;
      break;
    case "picture":
      value = verification.value ? <TooltipedPicture file={{src: verification.fileDownloadURL, fileName: "Archivo"}} /> : empty;
      break;
    case "ar_activation":
      verification.name = "Se utilizó Realidad Aumentada"
      value = <div className={classes.infoField}>{verification.value && verification.value.toLowerCase() === "true" ? "Si" : "No"}</div>;
      break;
    default:
      value = <div className={classes.infoField}>{verification.value ? verification.value : empty}</div>;
      break;
  }
  return <div className={classes.infoPair}>
      <div className={classes.infoHeader}>{verification.name}</div>
      {value}
  </div>
}

export default function MainContextWrapper({taskID, stepIndex, classes})
{
  if(!taskID) return null;

  return <VerificationsCtxProvider taskID={taskID} stepIndex={stepIndex}>
    <Iterator taskID={taskID} stepIndex={stepIndex} classes={classes}/>
  </VerificationsCtxProvider>
}

function Iterator({taskID, stepIndex, classes})
{
    const verificationsCtx = React.useContext(VerificationsCtx);
    if(verificationsCtx.loading) return null;

    return <>
      {verificationsCtx.data.array.map((verification, index) => <React.Fragment key={verification.verificationID}><TaskReportVerifications taskID={taskID} stepIndex={verification.stepIndex} key={verification.verificationID} verification={verification} classes={classes}/>{/* <Divider /> */}</React.Fragment>)}
    </>
}